import { render } from "./DropdownSucursal.vue?vue&type=template&id=131c8a2a"
import script from "./DropdownSucursal.vue?vue&type=script&lang=js"
export * from "./DropdownSucursal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__